import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Container, Row} from "react-bootstrap";

const LogosWrapper: React.FC = () => {
    const [deviceType, setDeviceType] = React.useState("desktop");

    React.useEffect(() => {
        const updateDeviceType = () => {
            const width = window.innerWidth;
            if (width < 768) {
                setDeviceType("mobile");
            } else if (width < 1024) {
                setDeviceType("tablet");
            } else {
                setDeviceType("desktop");
            }
        };

        updateDeviceType();
        window.addEventListener("resize", updateDeviceType);

        return () => window.removeEventListener("resize", updateDeviceType);
    }, []);

    return (
        <Container fluid>
            <Row>
                <div className="slider-container logoWrapper">
                    <Slider
                        dots={false}
                        autoplay={true}
                        speed={2000}
                        autoplaySpeed={2000}
                        cssEase="ease-in-out"
                        accessibility={false}
                        arrows={false}
                        touchMove={true}
                        slidesToShow={deviceType === "mobile" ? 2 : deviceType === "tablet" ? 3 : 4}
                    >
                        <div><a target="_blank" href="https://restaurantcafedechiapas.com"><img className="logoCFooter"
                                                                                src="/assets/logos/cafede.png"
                                                                                alt="Café de Chiapas"/></a></div>
                        <div><a target="_blank" href="https://pomarrosafloral.mx"><img className="logoCFooter"
                                                                       src="/assets/logos/pomarrosafloral.png"
                                                                       alt="Café de Chiapas"/></a></div>
                        <div><a href="#marcas"><img className="logoCFooter" src="/assets/logos/GO.png" alt="GO"/></a>
                        </div>
                        <div><a target="_blank" href="https://neblinastudio.mx"><img className="logoCFooter"
                                                                                     src="/assets/logos/neblina.png"
                                                                                     alt="NEBLINA"/></a></div>
                        <div><a target="_blank" href="https://patriciaguzman.mx"><img className="logoCFooter"
                                                                                      src="/assets/logos/logopgw.png"
                                                                                      alt="NEBLINA"/></a></div>
                        <div><a target="_blank" href="https://casalobe.mx"><img className="logoCFooter" src="/assets/logos/lobe.png"
                                                    alt="LOBE"/></a>
                        </div>
                        <div><a href="#marcas"><img className="logoCFooter" src="/assets/logos/meru.png"
                                                    alt="MERU"/></a>
                        </div>
                        <div><a target="_blank" href="https://tequilacasamorin.com"><img className="logoCFooter"
                                                                         src="/assets/logos/tequila.png" alt="TEQUILA"/></a>
                        </div>
                        <div><a target="_blank" href="https://www.jotacu.com"><img className="logoCFooter" src="/assets/logos/JQsol.png"
                                                                   alt="JQSOL"/></a></div>
                        <div><a href="#marcas"><img className="logoCFooter" src="/assets/logos/medical.png"
                                                    alt="MEDICAL"/></a>
                        </div>
                    </Slider>
                </div>
            </Row>
        </Container>
    )
        ;
};

export default LogosWrapper;
